import { callSyncNative, callAsyncNative } from './NativeFunctions';
import { GLOBAL_NAMESPACE, MODULE_NAMESPACE } from './Constants';
import CLSyncEngine from './CLSyncEngine';
try {
	callSyncNative('writeTraceMessage', 'Initializing CL Sync engine', Date.now());

	const global = window as any;
	global[GLOBAL_NAMESPACE] = {};
	global[GLOBAL_NAMESPACE][MODULE_NAMESPACE] = CLSyncEngine.getInstance();
	callAsyncNative('ready');
} catch (e) {
	callSyncNative('writeErrorMessage', e, Date.now());
}
